import { faBaby, faGamepad, faUsers, faUserTie, IconDefinition } from '@fortawesome/pro-light-svg-icons';

export enum SearchFilterAgeGroupType {
  ALL = 'all',
  CHILD = 'child',
  TEENAGER = 'teenager',
  ADULT = 'adult',
}

export interface AgeGroupOptionsProps {
  value: SearchFilterAgeGroupType;
  title: string;
  description: string;
  icon: IconDefinition;
}

export interface SearchFilterAgeGroupProps {
  name: string;
  description: string;
  icon: IconDefinition;
}

export const SearchFilterAgeGroupMap: Record<SearchFilterAgeGroupType, SearchFilterAgeGroupProps> = {
  [SearchFilterAgeGroupType.ALL]: {
    name: 'Todos',
    description: '',
    icon: faUsers,
  },
  [SearchFilterAgeGroupType.CHILD]: {
    name: 'Crianças',
    description: '(0 a 12 anos)',
    icon: faBaby,
  },
  [SearchFilterAgeGroupType.TEENAGER]: {
    name: 'Adolescentes',
    description: '(13 a 17 anos)',
    icon: faGamepad,
  },
  [SearchFilterAgeGroupType.ADULT]: {
    name: 'Adultos',
    description: '(acima de 18 anos)',
    icon: faUserTie,
  },
};
